import { stats } from "@api/stores/users/stats/api";

export const users = {
  stats,
};
